import { useEffect, useState } from "react";
import { Alert, Button, Container, IconButton } from "@mui/material";
import { NavLink } from "react-router-dom";

import { IEmployeeLight } from "../../../types/employee";

import { useUserContext } from "../../../contexts/userContext";
import { EmployeeService } from "../../../services/employeeService";

import EmployeeTable from "../../../components/tables/employeeTable";
import Navigation from "../../../components/header";
import PermissionGate from "../../../components/permissionGate";
import Spinner from "../../../components/spinner";

import "../../../styles/entity/employeeList.scss";
import { AppConfig } from "../../../config/appConfig";

const EmployeeList = () => {
	const userContext = useUserContext();
	const [gridView, setGridView] = useState<IEmployeeLight[]>();
	const [isLoadingEmployees, setIsLoadingEmployees] = useState(false);
	const [errorMessage, setErrorMessage] = useState<string | undefined>();

	const loadEmployeeData = async () => {
		setIsLoadingEmployees(true);
		setErrorMessage(undefined);

		EmployeeService.getEmployees()
			.then((response) => {
				console.log('EmployeeService.getEmployees: SUCCESS', response);
				let employees = EmployeeService.mapEmployeeLightList(response.data);
				setGridView(employees);
			})
			.catch((error) => {
				console.log('EmployeeService.getEmployees: ERROR', error);
				if (error?.code == "ERR_NETWORK") {
					setErrorMessage(AppConfig.apiConnectionErrorMessage)
				}
			})
			.finally(() => {
				setIsLoadingEmployees(false);
			});
	}

	useEffect(() => {
		loadEmployeeData();
	}, [])

	return (
		<div className="hwi-employee-list">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageEmployees}>
					<section className="hwi-entity-search-bar">
						<div className="search-header">
							<div className="title">Search Employees</div>
							<div><NavLink to="/employee/add"><Button variant="outlined">New Employee</Button></NavLink></div>
						</div>
					</section>
					<Spinner dependency={isLoadingEmployees} text="Loading Employees...">
						<section className="results">
							{errorMessage &&
								<Alert className="alert-error"
									severity="error">
									{errorMessage}
								</Alert>
							}
							{!errorMessage &&
								<EmployeeTable data={gridView}></EmployeeTable>
							}
						</section>
					</Spinner>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default EmployeeList;